import { useState } from 'react';
import { api } from '../../lib/api';
import { toast } from 'sonner';
import { TID } from '../../constants/testIds';

export default function NewsletterForm({ source = 'inline', tags = [], compact = false }) {
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        if (!email || busy) return;
        setBusy(true);
        try {
            await api.post('/leads/newsletter', { email, source, tags });
            setDone(true);
            toast.success('You are on the list. Welcome.');
            setEmail('');
        } catch (err) {
            toast.error('Something went wrong. Try again.');
        } finally {
            setBusy(false);
        }
    }

    if (done) {
        return (
            <div className="border border-neutral-300 p-4 text-sm">
                <span className="font-mono-data text-[11px] tracking-wider text-[#2F6B47]">CONFIRMED</span>
                <div className="mt-1">You&apos;ll receive the next briefing on Sunday morning.</div>
            </div>
        );
    }

    return (
        <div>
            <form onSubmit={onSubmit} className={`flex ${compact ? 'flex-row' : 'flex-col sm:flex-row'} gap-2`} data-testid={TID.home.newsletter}>
                <label htmlFor={`nl-email-${source}`} className="sr-only">Email address</label>
                <input
                    id={`nl-email-${source}`}
                    type="email"
                    required
                    placeholder="you@company.ca"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid={TID.home.newsletterInput}
                    className="flex-1 border border-neutral-300 px-3 py-2.5 text-[14px] bg-white focus:border-black focus:outline-none"
                />
                <button
                    type="submit"
                    disabled={busy}
                    data-testid={TID.home.newsletterSubmit}
                    className="bg-brand-navy text-white px-5 py-2.5 text-[13px] tracking-wide hover-invert hover:bg-brand-gold hover:text-brand-navy hover:border-brand-navy border border-brand-navy disabled:opacity-60"
                >
                    {busy ? 'Sending…' : 'Subscribe'}
                </button>
            </form>
            <p className="mt-2 text-[11px] leading-relaxed text-neutral-400">
                By subscribing you consent to receive the weekly briefing by email. Unsubscribe anytime — link in every issue.
            </p>
        </div>
    );
}
